import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const FORM_DIALOG_CLASS_NAME = 'FormDialog';
export const FORM_DIALOG_CLASS_SLOTS = [
	'root',
	'actions',
	'cancelButton',
	'content',
	'form',
	'progress',
	'submit',
] as const;

export type FormDialogClassSlot = (typeof FORM_DIALOG_CLASS_SLOTS)[number];

export interface FormDialogClasses {
	root: string;
	actions: string;
	cancelButton: string;
	content: string;
	form: string;
	progress: string;
	submitButton: string;
}

export type FormDialogClassKey = keyof FormDialogClasses;

export const getFormDialogUtilityClass = (slot: string) =>
	generateUtilityClass(FORM_DIALOG_CLASS_NAME, slot);

export const formDialogClasses: FormDialogClasses = generateUtilityClasses(
	FORM_DIALOG_CLASS_NAME,
	[
		'root',
		'actions',
		'cancelButton',
		'content',
		'form',
		'progress',
		'submitButton',
	],
);

export default formDialogClasses;
